module.exports = __webpack_public_path__ + "static/media/SI.fafe0bb7.png";